import { ExpandableText } from '../../components/ExpandableText';
import { ListItemCard } from '../../components/ListItemCard';
import { SkeletonCard, SkeletonRow } from '../../components/SkeletonCard';
import {
  CategoryHeading,
  CategoryImage,
  CategoryImagePlaceholder,
  DescriptionWrapper,
  LeftColumn,
  PageWrapper,
  PickerSlot,
  RightColumn,
} from './SpaCategoryDetailTemplate.styles';
import type { SpaCategoryDetailTemplateProps } from './SpaCategoryDetailTemplate.types';

export function SpaCategoryDetailTemplate({
  categoryName,
  categoryDescription,
  categoryImageUrl,
  imageAlt,
  items,
  onSelectItem,
  onEditSearch,
  journeyBar,
  isLoading,
  labels = {},
}: SpaCategoryDetailTemplateProps) {
  const { buttonLabel, unavailableLabel, editSearchLabel, showMoreLabel, showLessLabel } = labels;

  return (
    <PageWrapper>
      <PickerSlot>{journeyBar}</PickerSlot>
      <LeftColumn>
        {categoryImageUrl ? (
          <CategoryImage src={categoryImageUrl} alt={imageAlt ?? categoryName} loading="eager" />
        ) : (
          <CategoryImagePlaceholder data-testid="image-placeholder" />
        )}
        <CategoryHeading>{categoryName}</CategoryHeading>
        {categoryDescription && (
          <DescriptionWrapper>
            <ExpandableText
              text={categoryDescription}
              maxLines={3}
              showMoreLabel={showMoreLabel}
              showLessLabel={showLessLabel}
            />
          </DescriptionWrapper>
        )}
      </LeftColumn>

      <RightColumn>
        {isLoading ? (
          <SkeletonRow>
            {Array.from({ length: 3 }).map((_, i) => (
              <SkeletonCard key={i} variant="list" />
            ))}
          </SkeletonRow>
        ) : (
          items.map((item) => (
            <ListItemCard
              key={item.id}
              {...item}
              buttonLabel={item.buttonLabel ?? buttonLabel}
              unavailableLabel={item.unavailableLabel ?? unavailableLabel}
              editSearchLabel={item.editSearchLabel ?? editSearchLabel}
              onSelect={item.onSelect ?? (onSelectItem ? () => onSelectItem(item.id) : undefined)}
              onEditSearch={item.onEditSearch ?? onEditSearch}
            />
          ))
        )}
      </RightColumn>
    </PageWrapper>
  );
}
